import React, { useState, useEffect, useRef } from "react";
import ShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import "./style.css";
import anime from "animejs/lib/anime.es.js";
import slugify from "../../Utils/slugify";
export default function ProductCard({
  index,
  famille,
  livraisonGratuit,
  article,
  categorie,
  subcategorie,
  subSubcategorie,
  prixPromo,
  prixFlash,
  prix,
  colors,
  brand,
  reference,
  nouveau,
  stock,
  onAddToCart, // 1. AJOUT DE LA PROP ICI
}) {
  const [loading, setLoading] = useState(true);
  const [couleurSelectionnee, setCouleurSelectionnee] = useState(null);
  const [added, setAdded] = useState(false);
  const cardRef = useRef();

  // Traitement du nom et des chemins d'image
  const categoriee = article.split("-")[0];
  const articleName = article.split("-")[1];
  const articlImg = article.replace(/-/g, " ");

  let imagePath = "";
  let productLink = "";
if (subSubcategorie) {
  productLink = `/produit/${slugify(famille)}/${slugify(categorie)}/${slugify(subcategorie)}/${slugify(subSubcategorie)}/${slugify(articleName)}`;
} else if (subcategorie) {
  productLink = `/produit/${slugify(famille)}/${slugify(categorie)}/${slugify(subcategorie)}/${slugify(articleName)}`;
} else {
  productLink = `/produit/${slugify(famille)}/${slugify(categoriee)}/${slugify(articleName)}`;
}
  if (subSubcategorie) {
    imagePath = `${famille}/${categorie}/${subcategorie}/${subSubcategorie}/${articlImg}`;
  } else if (subcategorie) {
    imagePath = `${famille}/${categorie}/${subcategorie}/${articlImg}`;
  } else {
    imagePath = `${famille}/${categoriee}/${articlImg}`;
  }

  const imageUrl = `https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${encodeURIComponent(
    imagePath
  )}.jpeg?alt=media`;

  // 1. Effet pour détecter la fin du chargement de l'image
  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => setLoading(false);
    // En cas d'erreur de chargement, on arrête aussi le skeleton
    img.onerror = () => setLoading(false);
  }, [imageUrl]);

  // 2. Animation au scroll (uniquement quand loading est faux)
  useEffect(() => {
    if (!loading) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              anime({
                targets: entry.target,
                opacity: [0, 1],
                translateY: [40, 0],
                easing: "easeOutExpo",
                duration: 700,
              });
            }
          });
        },
        { threshold: 0.2 }
      );

      if (cardRef.current) {
        observer.observe(cardRef.current);
      }

      return () => observer.disconnect();
    }
  }, [loading]);

  // --- ajout au panier ---
  const addToCart = () => {
    if (stock <= 0) return;

    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
    let productExists = false;

    existingCart.forEach((product) => {
      if (product.name === articleName && product.color === couleurSelectionnee) {
        productExists = true;
        product.quantite += 1;
      }
    });

    if (!productExists) {
      let price = prixPromo ? prixPromo : prixFlash ? prixFlash : prix;
      const product = {
        family: famille,
        name: articleName,
        img: articlImg,
        categorie,
        souscategorie: subcategorie,
        soussouscategorie: subSubcategorie,
        price: price.toFixed(3),
        brand,
        reference,
        livraisonGratuit,
        quantite: 1,
        color: couleurSelectionnee,
      };
      existingCart.push(product);
    }

    localStorage.setItem("cart", JSON.stringify(existingCart));
    
    // Afficher l'état "Ajouté !"
    setAdded(true);
    
    // 2. APPEL DE LA PROP AU LIEU DE L'ÉVÉNEMENT
    if (onAddToCart) {
      onAddToCart();
    }

    // 3. BONUS UX : Remettre le bouton à son état normal après 2 secondes
    setTimeout(() => {
      setAdded(false);
    }, 2000);
  };

  const discountPercent = prixPromo
    ? Math.round(((prix - prixPromo) / prix) * 100)
    : prixFlash
    ? Math.round(((prix - prixFlash) / prix) * 100)
    : null;

  // RENDU DU SKELETON
  if (loading) {
    return (
      <div className="product-card">
        <div className="skeleton skeleton-img"></div>
        <div className="info">
          <div className="skeleton skeleton-text" style={{ width: '85%' }}></div>
          <div className="skeleton skeleton-text" style={{ width: '50%' }}></div>
          <div className="skeleton skeleton-price"></div>
          <div className="skeleton skeleton-btn"></div>
        </div>
      </div>
    );
  }

  // RENDU RÉEL
  return (
    <div ref={cardRef} className="product-card card-anim">
      {discountPercent > 0 && <div className="badge promo">-{discountPercent.toFixed(0)}%</div>}
      {nouveau === true && <div className="badge new">Nouveau</div>}

      <a className="cardMediaLink" href={productLink}>
        <img src={imageUrl} alt={articleName} className="product-img" />
      </a>

      <div className="info">
        <h3 className="title">{articleName}</h3>
        <p className="desc">{brand}</p>

        <div className="price">
          {prixFlash ? (
            <>
              <span className="old-price">{prix.toFixed(3)} TND</span>
              <span className="new-price">{prixFlash.toFixed(3)} TND</span>
            </>
          ) : prixPromo ? (
            <>
              <span className="old-price">{prix.toFixed(3)} TND</span>
              <span className="new-price">{prixPromo.toFixed(3)} TND</span>
            </>
          ) : (
            <span className="new-price">{prix.toFixed(3)} TND</span>
          )}
        </div>

        {colors && colors.length > 0 && (
          <div className="colors-container">
            {colors.map((color, i) => (
              <img
                key={i}
                src={require(`../../images/colors/${color}.jpeg`)}
                alt={color}
                className={`color-circle ${color === couleurSelectionnee ? "selected" : ""}`}
                onClick={() => setCouleurSelectionnee(color)}
              />
            ))}
          </div>
        )}

        <button
          className={`add-cart-btn ${stock <= 0 ? "disabled" : ""} ${added ? "added" : ""}`}
          onClick={addToCart}
          disabled={stock <= 0}
        >
          <span>{added ? "Ajouté !" : "Ajouter au panier"}</span>
          {added ? null : <ShoppingCartIcon style={{ fontSize: 20 }} />}
        </button>

        {stock <= 0 && <p className="out-stock">En arrivage</p>}
      </div>
    </div>
  );
}